import { getApi } from "@/utils/fetch";
import { ShopInfoResponse } from "@/utils/shop";

const fetchShopsAsync = async (abort: AbortController, contractId: number): Promise<ShopInfoResponse> => {
 const params = new URLSearchParams();
  params.set("contractId", `${contractId}`);
    return getApi<ShopInfoResponse>(`/api/contract/shops?${params.toString()}`);
};

export default {
  fetchShopsAsync,
};
